import {
  ApiGetCollection,
  ApiGetCollectionPage,
  ApiGetCollectionReadPopularPage,
  ApiPostCollection,
  ApiPutCollection,
} from "@/apis/collection";
import { defineStore } from "pinia";
import { useMate } from "./mate";
import { Collection } from "@/types/collection";

export const useCollection = defineStore("collection", {
  state: () => ({
    myCollection: [] as Collection[],
    collectionMap: {} as Record<number, Collection>,

    activeTab: "recommend" as "recommend" | "latest",
    isLoadingNewList: false,
    discoverList: {
      // 推荐
      recommend: {
        scrollTop: 0,
        list: [] as number[],
      },
      // 最新
      latest: {
        scrollTop: 0,
        list: [] as number[],
      },
    }, // 最新
  }),
  getters: {
    discoverCurrentList(state) {
      return state.discoverList[state.activeTab];
    },
  },
  actions: {
    async getMyCollection() {
      const res = await ApiGetCollectionPage({
        filter: {
          targetMateId: useMate().userMate!.id!,
          currentMateId: useMate().userMate!.id!,
        },
      });
      this.myCollection = res.page.data;
      this.myCollection.forEach((c) => (this.collectionMap[c.id!] = c));
    },
    async getCollectionByMateId(mateId: number) {
      const res = await ApiGetCollectionPage({
        filter: {
          targetMateId: mateId,
          currentMateId: useMate().userMate?.id!,
        },
      });
      this.myCollection = res.page.data;
      this.myCollection.forEach((c) => (this.collectionMap[c.id!] = c));
    },
    async getCollection(uuid: string) {
      const res = await ApiGetCollection(uuid);
      this.collectionMap[res.item.id!] = res.item;
      return res.item;
    },
    async fetchDiscoverList() {
      const { list } = this.discoverCurrentList;
      const pageNum = list.length / 12 + 1;
      if (!Number.isInteger(pageNum)) return false;
      this.isLoadingNewList = true;
      const { page } = await ApiGetCollectionReadPopularPage(
        { tab: this.activeTab === "recommend" ? "hot" : undefined },
        { page: pageNum, perPage: 12 }
      );
      this.isLoadingNewList = false;
      const tmpList = page.data
        .map((collection: Collection) => {
          this.collectionMap[collection.id!] = collection;
          return collection.id!;
        })
        // 随机排序
        .sort(() => Math.random() - 0.5);

      this.discoverCurrentList.list = [...list, ...tmpList];
      if (list.length === page.total) return false;
      return page.data.length === 12;
    },
    async createCollection(params: Partial<Collection>) {
      const res = await ApiPostCollection(params);
      this.myCollection.push(res.item);
      this.myCollection.forEach((c) => (this.collectionMap[c.id!] = c));
    },
    async updateCollection(uuid: string, params: Partial<Collection>) {
      const res = await ApiPutCollection(uuid, params);
      const item = this.myCollection.find((c) => c.id === res.item.id);
      if (item) {
        for (const key in params) {
          item[key] = params[key];
        }
      }
    },
  },
});
